import { useEffect, useState } from "react";
import { getAuthHeader } from "../../../utils/getAuthHeader";
import { getEnterpriseName } from "../../../api";
import { useAuth } from "../Auth";
import { API_BASE_ADMIN, EnterpriseOption, MappingRow, PaginationMeta, SearchBy } from "../../components/iot_device_mapping/types";
import TriggerSyncCard from "../../components/iot_device_mapping/TriggerSyncCard";
import CsvUploadCard from "../../components/iot_device_mapping/CsvUploadCard";
import MappingsTable from "../../components/iot_device_mapping/MappingsTable";

export default function IotDeviceMapping() {
  const { currentUser } = useAuth();
  const isPrivileged = currentUser?.role === "Admin" || currentUser?.role === "Operations" || currentUser?.role === "Agronomist";

  const [mappings, setMappings]       = useState<MappingRow[]>([]);
  const [loading, setLoading]         = useState(false);
  const [pagination, setPagination]   = useState<PaginationMeta>({ total: 0, total_pages: 1, page: 1, page_size: 10 });
  const [enterprises, setEnterprises] = useState<EnterpriseOption[]>([]);

  const fetchMappings = async (
    page = 1,
    search_by?: SearchBy,
    search_value?: string,
    enterprise_id?: number | null
  ) => {
    setLoading(true);
    try {
      let url = `${API_BASE_ADMIN}/iot_endpoints/iot-farm-mappings?page=${page}&page_size=10`;
      if (search_value?.trim()) url += `&search_by=${search_by}&search_value=${encodeURIComponent(search_value.trim())}`;
      if (enterprise_id)        url += `&enterprise_id=${enterprise_id}`;

      const res = await fetch(url, { headers: { ...getAuthHeader() } });

      if (res.status === 404) {
        setMappings([]);
        setPagination({ total: 0, total_pages: 1, page: 1, page_size: 10 });
        return;
      }
      if (!res.ok) throw new Error(`API Error: ${res.status}`);

      const data = await res.json();
      setMappings(data.data || []);
      setPagination({ total: data.total, total_pages: data.total_pages, page: data.page, page_size: data.page_size });
    } catch (err) {
      console.error("Error fetching IoT mappings:", err);
      setMappings([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMappings(1); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getEnterpriseName()
      .then((list: any[]) => {
        const sorted = [...list].sort((a, b) => a.name.localeCompare(b.name));
        setEnterprises(sorted.map((e) => ({ value: e.id, label: e.name })));
      })
      .catch(() => {});
  }, []);

  return (
    <div className="container-fluid py-4">
      <h3 className="fw-bold mb-4">IoT Device Mapping</h3>

      <TriggerSyncCard onSuccess={() => fetchMappings(1)} />

      {isPrivileged && (
        <CsvUploadCard onSuccess={() => fetchMappings(1)} />
      )}

      <MappingsTable
        mappings={mappings}
        loading={loading}
        pagination={pagination}
        enterprises={enterprises}
        isPrivileged={isPrivileged}
        fetchMappings={fetchMappings}
      />
    </div>
  );
}
